import React, {useEffect} from 'react';
import IMG from "../constants/image";
import './style.css'
import StepRegisterSuccess from "../components/Login/StepRegisterSuccess";
import StepPhone from "../components/Login/StepPhone";
import StepInputOTP from "../components/Login/StepInputOTP";
import StepCreatePassword from "../components/Login/StepCreatePassword";
import {PATH} from "../constants";
import {useNavigate} from "react-router-dom";
import StepLoginPassword from "../components/Login/StepLoginPassword";
import DescItem from "../components/Login/DescItem";

const LoginPage = () => {
  const navigate = useNavigate();
  const [step, setStep] = React.useState(0);
  const [forgot, setForgot] = React.useState(false);

  useEffect(() => {
    if (step === 4) {
      setTimeout(() => {
        navigate(PATH.ONBOARDING)
      }, 3000);
    }
  }, [step]);


  return (
    <div className="relative mx-auto h-full w-full animate-fadeIn md:h-[700px]">
      <picture className='absolute w-full h-full'>
        <source media="(min-width: 768px)" srcSet={IMG.bgLogin}/>
        <img className='md:h-full w-full' src={IMG.bgLoginMb} alt='loginInfoGraphic'/>
      </picture>
      <div className='flex flex-col justify-center items-center h-full bg-transparent pt-5'>
        <div className='flex flex-col md:flex-row justify-center items-center z-[1] gap-[35px]'>
          <div className='flex flex-col justify-center px-[25px] text-white md:w-[550px] gap-2.5'>
            <img className='md:hidden' src={IMG.loginInfoGraphic} alt=""/>
            <div className='hidden md:block'>
              <p className='text-sm'>FUTA FuNong - Nơi kết nối trực tiếp từ nông dân đến người tiêu dùng</p>
              <p className='font-bold text-2xl'>Trở thành Nhà Bán Hàng ngay hôm nay!</p>
              <DescItem
                imgSrc={IMG.od}
                title='100% miễn phí sàn - Thoải mái bán hàng'
                desc='Người bán hàng được đăng sản phẩm trên sàn TMĐT FUTA FuNong hoàn toàn miễn phí và không phải chịu bất kỳ khoản phí hoa hồng cũng như phí duy trì nào'
              />
              <DescItem
                imgSrc={IMG.van}
                title='Vận chuyển nhanh chóng, tiết kiệm'
                desc='Cùng đối tác vận chuyển FUTA Express, và đội ngũ hậu cần chuyên về nông sản và nông nghiệp, bạn sẽ được hưởng những đặc quyền về vận chuyển nhanh chóng cùng mức chi phí tối ưu '
              />
              <DescItem
                imgSrc={IMG.userGroup}
                title='Dễ dàng tiếp cận đến tận tay người tiêu dùng'
                desc='Sản phẩm được quảng bá rộng rãi qua nhiều kênh truyền thông, đặc biệt là trong hệ sinh thái của tập đoàn Phương Trang, giúp tăng nhận diện thương hiệu và thu hút đông đảo khách hàng.'
              />
            </div>
          </div>
          {step <= 0 && <StepPhone setStep={setStep}/>}
          {step === 1 && <StepInputOTP forgot={forgot} setStep={setStep}/>}
          {step === 2 && <StepCreatePassword setStep={setStep} forgot={forgot}/>}
          {step === 3 && <StepLoginPassword setStep={setStep} setForgot={setForgot}/>}
          {step === 4 && <StepRegisterSuccess setStep={setStep}/>}
        </div>
      </div>
      <div
        className='md:hidden text-center text-white text-[10px] bg-[#197D55] fixed bottom-0 left-0 right-0 flex flex-col justify-center items-center h-[66px] gap-2.5'>
        <p>© 2024 - Bản quyền thuộc về<br/>CÔNG TY CP THƯƠNG MẠI ĐIỆN TỬ VẬN THÔNG</p>
        <p>Một sản phẩm của FUTA Group</p>
      </div>
    </div>
  );
}

export default LoginPage;
